var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPowerBuilder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "rewards/power-builder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "7.03125e-05 0 45 0 45 48 7.03125e-05 48"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "7.03125e-05 0 45 0 45 44.5217391 7.03125e-05 44.5217391"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Product",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Rewards-1440",
    transform: "translate(-217.000000, -297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rewards/power-builder",
    transform: "translate(217.000000, 297.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7813203,48 L4.21882031,48 C1.88901563,48 7.03125e-05,46.1311304 7.03125e-05,43.826087 L7.03125e-05,4.17391304 C7.03125e-05,1.86886957 1.88901563,0 4.21882031,0 L40.7813203,0 C43.111125,0 45.0000703,1.86886957 45.0000703,4.17391304 L45.0000703,43.826087 C45.0000703,46.1311304 43.111125,48 40.7813203,48",
    id: "Fill-1",
    fill: "#D3A900",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7813203,44.5217391 L4.21882031,44.5217391 C1.88901563,44.5217391 7.03125e-05,42.6528696 7.03125e-05,40.3478261 L7.03125e-05,4.17391304 C7.03125e-05,1.86886957 1.88901563,0 4.21882031,0 L40.7813203,0 C43.111125,0 45.0000703,1.86886957 45.0000703,4.17391304 L45.0000703,40.3478261 C45.0000703,42.6528696 43.111125,44.5217391 40.7813203,44.5217391",
    id: "Fill-4",
    fill: "#FFDC4A",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32.2359961,16.2569391 L30.6019336,17.8743304 C30.6019336,17.8743304 29.5113867,18.4134609 28.4218945,17.3348522 C27.3313477,16.2569391 27.8766211,15.1783304 27.8766211,15.1783304 L29.5113867,13.5609391 C30.0570117,13.0218087 29.4016992,12.5275478 28.9102148,12.5275478 C26.4956836,12.5275478 24.5388867,14.4635478 24.5388867,16.8517217 C24.5388867,17.1880696 24.5817773,17.5129391 24.6545508,17.8273739 L20.9596289,21.4826783 L24.2291602,24.7174609 L27.9244336,21.0618087 C28.2422461,21.1341565 28.5706055,21.1762435 28.9102148,21.1762435 C31.324043,21.1762435 33.2808398,19.2402435 33.2808398,16.8517217 C33.2808398,16.3623304 32.780918,15.7174609 32.2359961,16.2569391",
    id: "Fill-7",
    fill: "#8E9FA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2585156,31.3022957 C14.7701953,31.3022957 14.3750391,30.9109913 14.3750391,30.4282087 C14.3750391,29.9454261 14.7701953,29.5537739 15.2585156,29.5537739 C15.7464844,29.5537739 16.1416406,29.9454261 16.1416406,30.4282087 C16.1416406,30.9109913 15.7464844,31.3022957 15.2585156,31.3022957 L15.2585156,31.3022957 Z M20.8951172,21.587513 L13.6307812,28.7746435 C12.7388672,29.6570783 12.7388672,31.0869913 13.6307812,31.9690783 C14.5223437,32.8508174 15.9672656,32.8508174 16.8595312,31.9690783 L24.1231641,24.7819478 L20.8951172,21.587513 Z",
    id: "Fill-9",
    fill: "#8E9FA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.39175,32.152313 C30.0867891,32.8399652 31.1931563,32.872313 31.8481172,32.2236174 C32.5037813,31.5749217 32.4707344,30.4810087 31.7760469,29.7933565 L17.9090156,16.0733565 C17.2143281,15.3860522 16.1086641,15.3537043 15.453,16.0020522 C14.7973359,16.6510957 14.8300313,17.7446609 15.5250703,18.432313 L29.39175,32.152313 Z",
    id: "Fill-11",
    fill: "#E80F62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7974766,13.0539826 C23.7974766,13.0539826 20.2213828,11.2849391 17.2411875,14.2334609 C14.5591172,16.8870261 13.0688438,18.361113 13.0688438,18.361113 C13.0688438,18.361113 12.4729453,17.7715478 11.8770469,18.361113 L11.2807969,18.9510261 C11.2807969,18.9510261 10.6848984,19.5405913 11.2807969,20.1301565 C11.8770469,20.7200696 13.6650938,22.489113 13.6650938,22.489113 C13.6650938,22.489113 14.2609922,23.0786783 14.8568906,22.489113 L15.4531406,21.8995478 C15.4531406,21.8995478 16.0490391,21.3096348 15.4531406,20.7200696 L15.4067344,20.6741565 C15.8655234,20.2358957 16.5528281,19.789287 17.2411875,20.1301565 L19.6251328,17.7715478 C19.6251328,17.7715478 19.0292344,16.0025043 20.2213828,14.8230261 C21.4135312,13.6435478 22.0094297,13.6435478 23.2015781,13.6435478 C24.3937266,13.6435478 23.7974766,13.0539826 23.7974766,13.0539826",
    id: "Fill-13",
    fill: "#8E9FA8"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerBuilder);
export default __webpack_public_path__ + "static/media/power-builder.216699e4112e63d9a4f4017cf412461f.svg";
export { ForwardRef as ReactComponent };